export default __webpack_public_path__ + "static/media/TITAN-ETH.2dfd7b9c.png";